import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobListingService {

  constructor(private http: HttpClient) { }

  getDepartmentVacancies(departmentId: bigint){
    return this.http.get(`${environment.apiUrl}/v1/vacancies/` + departmentId);
  }

  genericSearch(value: any){
    return this.http.get(`${environment.apiUrl}/v1/vacancies/generic-search/` + value);
  }

  searchByJobType(value: any){
    return this.http.post(`${environment.apiUrl}/v1/vacancies/search-by-job-type/`, value);
  }

  getJobTypes(){
    return this.http.get<any>(`${environment.apiUrl}/v1/job-types`);
    // return this.http.get<any>(`${environment.apiUrl}/v1/job-types`);
  }
}
